import { COLORS } from 'constants/index';
import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
    root: {
        color: COLORS.apariBlack80
    }
}));
